import React, { useState } from 'react';
import DataTable from './DataTable';

const PaginatedTable = ({
  data,
  columns,
  onEdit,
  onDelete,
  onView,
  onAdd,
  itemsPerPage = 20,
  moduleName
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentData = data.slice(startIndex, startIndex + itemsPerPage);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <div className="space-y-4">
      <DataTable
        data={currentData}
        columns={columns}
        onEdit={onEdit}
        onDelete={onDelete}
        onView={onView}
        onAdd={onAdd}
        moduleName={moduleName}
      />

      {totalPages > 1 && (
        <div className="flex flex-wrap items-center justify-center gap-1 text-sm">
          <button
            onClick={() => goToPage(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-2.5 py-1 rounded-md bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          >
            Prev
          </button>

          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => goToPage(i + 1)}
              className={`px-2.5 py-1 rounded-md transition ${
                currentPage === i + 1
                  ? 'bg-green-600 text-white'
                  : 'bg-gray-200 hover:bg-gray-300'
              }`}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={() => goToPage(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-2.5 py-1 rounded-md bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default PaginatedTable;
